// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "#/components/module_list/ModuleList";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class TabModule extends ModuleBase {
  @Prop({ default: "ErrorWidget" })
  public type!: string;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
